import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/cash.svg'
import _imports_1 from '@/app/ui/assets/svg/coin-yellow.svg'


const _hoisted_1 = { class: "balance-list pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full font-montserrat" }
const _hoisted_2 = { class: "w-full px-1 pt-8 flex flex-col gap-y-8 mb-8 border-gray-lp-200" }
const _hoisted_3 = { class: "flex flex-row w-full px-2 py-3 shadow-balance border border-gray-lp-900 rounded-lg" }
const _hoisted_4 = { class: "flex flex-col p-5 pb-1 border-r w-4/12 " }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-normal text-gray-lp-300" }, "Saldo", -1)
const _hoisted_7 = { class: "flex flex-row" }
const _hoisted_8 = { class: "text-20px font-semibold pt-2" }
const _hoisted_9 = { class: "flex flex-col p-5 pb-1 border-r w-4/12 mx-4" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-normal text-gray-lp-300" }, "Poin", -1)
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = { class: "text-20px font-semibold pt-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "bg-gray-lp-1400 py-0 rounded mx-2 px-2 my-4 text-gray-lp-300 text-10px whitespace-nowrap" }, " 1 Poin senilai 1 Rupiah ", -1)
const _hoisted_15 = { class: "flex flex-col p-5 pb-1 border-r w-1/5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-16px font-normal text-gray-lp-300" }, "Membership")
], -1)
const _hoisted_17 = { class: "flex flex-row" }
const _hoisted_18 = { class: "text-20px font-semibold pt-2 text-yellow-lp-1300" }
const _hoisted_19 = { class: "flex flex-col p-5 pb-1 justify-start" }
const _hoisted_20 = { class: "flex flex-row" }
const _hoisted_21 = { class: "flex flex-col overflow-hidden pt-4 w-full bg-white" }
const _hoisted_22 = { class: "flex gap-x-6 text-20px border-b border-gray-lp-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ModalInfoSaldo = _resolveComponent("ModalInfoSaldo")!
  const _component_ModalTarikSaldo = _resolveComponent("ModalTarikSaldo")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: _imports_0,
                class: ["w-6", 'mr-2'],
                alt: "coin"
              }),
              _hoisted_6
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.balance), 1),
              _createVNode(_component_LpButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleInfoSaldoDialog(true))),
                outline: "",
                title: "Detail Saldo",
                textColor: "red-lp-100",
                textSize: 10,
                iconV2: "",
                iconLeft: "eye",
                iconColor: "red-lp-100",
                class: "ml-2 pt-2.5",
                customClass: "whitespace-nowrap",
                tight: ""
              })
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: _imports_1,
                class: ["w-6", 'mr-2'],
                alt: "coin"
              }),
              _hoisted_11
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("p", _hoisted_13, _toDisplayString(_ctx.point), 1),
              _hoisted_14
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _createVNode("p", _hoisted_18, _toDisplayString(_ctx.customerLevel), 1)
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_LpButton, {
                title: "Tarik Saldo",
                textColor: "white",
                textSize: 10,
                class: "ml-6 mt-2",
                customClass: "whitespace-nowrap",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTarikSaldoDialog(true)))
              })
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock("button", {
              key: tab.name,
              onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
              class: 
            `pb-4 font-semibold hover:text-red-lp-100 focus:outline-none ${
              _ctx.isTabActive(tab.name)
                ? 'text-red-lp-100 border-b-2 border-red-lp-100'
                : 'text-gray-lp-600'
            }`
          
            }, _toDisplayString(tab.title), 11, ["onClick"]))
          }), 128))
        ]),
        _createVNode(_component_router_view)
      ])
    ]),
    (_ctx.infoSaldoModelValue)
      ? (_openBlock(), _createBlock(_component_ModalInfoSaldo, {
          key: 0,
          modelValue: _ctx.infoSaldoModelValue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.infoSaldoModelValue = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.tarikSaldoModelValue)
      ? (_openBlock(), _createBlock(_component_ModalTarikSaldo, {
          key: 1,
          modelValue: _ctx.tarikSaldoModelValue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tarikSaldoModelValue = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}